/**
 * 오버플로우 핸들러 훅
 * 
 * 미디어 그리드에서 오버플로우(+2 등) 클릭 처리 로직을 제공합니다.
 */ export function useOverflowHandler(// 필수 파라미터
hiddenMedia, hiddenCount) {
    var // 선택적 파라미터
    normalVideos = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], shortFormVideos = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], images = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], // 설정 옵션
    useBuiltInModal = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : true, onOverflowClick = arguments.length > 6 ? arguments[6] : void 0, // 내장 모달 관련
    openModal = arguments.length > 7 ? arguments[7] : void 0;
    /**
   * 오버플로우 클릭 핸들러
   */ var handleOverflowClick = function(e) {
        e.stopPropagation();
        // 외부 핸들러가 있고 내장 모달을 사용하지 않는 경우
        if (onOverflowClick && !useBuiltInModal) {
            var hiddenNormalVideoUrls = hiddenMedia.filter(function(media) {
                return normalVideos.includes(media);
            });
            var hiddenShortFormVideoUrls = hiddenMedia.filter(function(media) {
                return shortFormVideos.includes(media);
            });
            var hiddenImageUrls = hiddenMedia.filter(function(media) {
                return images.includes(media);
            });
            onOverflowClick({
                images: hiddenImageUrls,
                videos: hiddenNormalVideoUrls,
                shortFormVideos: hiddenShortFormVideoUrls,
                totalCount: hiddenCount
            });
        } else if (useBuiltInModal && openModal) {
            // 내장 모달 열기
            openModal(0);
        }
    };
    return {
        handleOverflowClick: handleOverflowClick
    };
}
export default useOverflowHandler;
